import React, { useState, useEffect, useMemo } from "react";
import { NavLink } from "react-router-dom";
import api from "@api";
import DefaultImg from "./image/default.png";
import { useDomain } from "@useDomain";
import "./PlayerListPublic.css";

function PlayerListPublic() {
 const [players, setPlayers] = useState([]);
 const [selectedLeague, setSelectedLeague] = useState("");
 const [selectedTeam, setSelectedTeam] = useState("");
 const [searchTerm, setSearchTerm] = useState("");
 const [loading, setLoading] = useState(true);
 const { domain, slug, organization } = useDomain();
 const theme = organization?.theme_mode || "light";
 const primaryColor =
  organization?.primaryColor ||
  organization?.primary_color ||
  "#1e60c4";
  const [playerView, setPlayerView] = useState("active");

  
 useEffect(() => {
  const fetchPlayers = async () => {
   try {
    setLoading(true);

 

     const response = await api.get("/api/playersv2", {
       params: {
         ...(slug ? { slug } : { domain }),
         public_view: true,
       },
     });

    setPlayers(response.data.players || []);
   } catch (error) {
    console.error("Error fetching players:", error);
   } finally {
    setLoading(false);
   }
  };
   console.log("PLAYER LIST DOMAIN:", domain);
   console.log("PLAYER LIST SLUG:", slug);
  if (domain || slug) fetchPlayers();
 }, [domain, slug]);

  const leagueOptions = useMemo(() => {
    const teamLeagues = players
      .flatMap((player) => player.rosters || [])
      .filter(
        (roster) =>
          roster.league?.id &&
          roster.seasons_leagues_team?.seasons_league?.season?.active
      )
      .map((roster) => ({
        id: roster.league.id,
        name: roster.league.name,
        league_type: roster.league.league_type,
      }));

    const individualLeagues = players
      .flatMap((player) => player.individualLeagues || [])
      .filter(
        (entry) =>
          entry.league?.id &&
          entry.season?.active
      )
      .map((entry) => ({
        id: entry.league.id,
        name: entry.league.name,
        league_type: entry.league.league_type,
      }));

    return [...teamLeagues, ...individualLeagues]
      .reduce((acc, league) => {
        if (!acc.some((item) => item.id === league.id)) {
          acc.push(league);
        }
        return acc;
      }, [])
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [players]);

  useEffect(() => {
  if (
    playerView === "active" &&
    leagueOptions.length === 1 &&
    !selectedLeague
  ) {
    setSelectedLeague(String(leagueOptions[0].id));
  }
}, [leagueOptions, selectedLeague, playerView]);

 const filteredTeams = useMemo(() => {
  return players
   .flatMap((player) => player.rosters || [])
   .filter(
    (roster) =>
     roster.team?.id &&
     (!selectedLeague || roster.league?.id === Number(selectedLeague)) &&
     roster.seasons_leagues_team?.seasons_league?.season?.active
   )
   .reduce((acc, roster) => {
    if (!acc.some((team) => team.id === roster.team.id)) {
     acc.push({
      id: roster.team.id,
      name: roster.team.name,
     });
    }
    return acc;
   }, [])
   .sort((a, b) => a.name.localeCompare(b.name));
 }, [players, selectedLeague]);

 const filteredPlayers = useMemo(() => {
  return players
   .filter((player) => {
    const fullName =
     `${player.firstName || ""} ${player.lastName || ""}`.toLowerCase();

    const matchesSearch = fullName.includes(searchTerm.toLowerCase());

     const matchesTeamLeague = player.rosters?.some(
       (roster) =>
         roster.league?.id === Number(selectedLeague) &&
         roster.seasons_leagues_team?.seasons_league?.season?.active
     );

     const matchesIndividualLeague = player.individualLeagues?.some(
       (entry) =>
         entry.league?.id === Number(selectedLeague) &&
         entry.season?.active
     );

     const matchesLeague = selectedLeague
       ? matchesTeamLeague || matchesIndividualLeague
       : true;
     const isActiveTeamPlayer = player.rosters?.some(
       (roster) =>
         roster.seasons_leagues_team?.seasons_league?.season?.active
     );

     const isActiveIndividualPlayer = player.individualLeagues?.some(
       (entry) => entry.season?.active
     );

     const isActivePlayer =
       isActiveTeamPlayer || isActiveIndividualPlayer;

     const matchesView =
       playerView === "all" ? true : isActivePlayer;
    const matchesTeam = selectedTeam
     ? player.rosters?.some(
      (roster) => roster.team?.id === Number(selectedTeam)
     )
     : true;

     return matchesView && matchesSearch && matchesLeague && matchesTeam;
   })
   .sort((a, b) =>
    `${a.firstName || ""} ${a.lastName || ""}`.localeCompare(
     `${b.firstName || ""} ${b.lastName || ""}`
    )
   );
 }, [players, searchTerm, selectedLeague, selectedTeam, playerView]);

 const wrapperStyle = {
  "--players-primary": primaryColor,
 };

 if (loading) {
  return (
   <div
    className={`playersDefault playersDefault--${theme} loading-container`}
    style={wrapperStyle}
   >
    <div className="playersDefault-spinner" />
    <p className="playersDefault-loading-text">Loading players...</p>
   </div>
  );
 }





  const selectedLeagueObj = leagueOptions.find(
    (league) => league.id === Number(selectedLeague)
  );
  const isIndividualLeague = players.some((player) =>
    player.individualLeagues?.some(
      (entry) =>
        entry.league?.id === Number(selectedLeague) &&
        entry.season?.active
    )
  );

 return (
  <div
   className={`playersDefault playersDefault--${theme}`}
   style={wrapperStyle}
  >
   {players.length === 0 ? null : (
    <>
         <div className="playersDefault-view-toggle">
           <button
             type="button"
             className={`playersDefault-view-btn ${playerView === "active" ? "active" : ""
               }`}
             onClick={() => setPlayerView("active")}
           >
             Active Players
           </button>

           <button
             type="button"
             className={`playersDefault-view-btn ${playerView === "all" ? "active" : ""
               }`}
             onClick={() => {
               setPlayerView("all");
               setSelectedLeague("");
               setSelectedTeam("");
             }}
           >
             All Players
           </button>
         </div>
     <div className="playersDefault-controls">
      <input
       type="text"
       placeholder="Search player name..."
       value={searchTerm}
       onChange={(e) => setSearchTerm(e.target.value)}
       className="playersDefault-search"
      />

           <div className="playersDefault-filters">

             {leagueOptions.length > 1 && (
               <select
                 value={selectedLeague}
                 onChange={(e) => {
                   setSelectedLeague(e.target.value);
                   setSelectedTeam("");
                 }}
                 className="playersDefault-select"
               >
                 <option value="">-- LEAGUES --</option>

                 {leagueOptions.map((league) => (
                   <option key={league.id} value={league.id}>
                     {league.name}
                   </option>
                 ))}
               </select>
             )}

             {!isIndividualLeague && filteredTeams.length > 1 && (
               <select
                 value={selectedTeam}
                 onChange={(e) => setSelectedTeam(e.target.value)}
                 className="playersDefault-select"
               >
                 <option value="">-- TEAMS --</option>

                 {filteredTeams.map((team) => (
                   <option key={team.id} value={team.id}>
                     {team.name}
                   </option>
                 ))}
               </select>
             )}

           </div>
     </div>

     <div className="playersDefault-grid">
      {filteredPlayers.map((player) => {
       const hasRealImage = Boolean(player.image && player.image !== DefaultImg);

       return (
        <div key={player.id} className="playersDefault-card">
         <NavLink
          to={slug ? `/${slug}/players/${player.id}` : `/players/${player.id}`}
          className="playersDefault-link"
         >
          <img
           src={player.image || DefaultImg}
           alt={`${player.firstName || ""} ${player.lastName || ""}`}
           className={`playersDefault-image ${hasRealImage
             ? "playersDefault-image--real"
             : "playersDefault-image--default"
            }`}
          />

          <p className="playersDefault-name">
           {player.firstName} {player.lastName}
          </p>
         </NavLink>
        </div>
       );
      })}
     </div>
    </>
   )}
  </div>
 );
}

export default PlayerListPublic;